import { Component } from '@angular/core';
import { ANGULAR_MODULES, OperationsComponent, SYNCFUSION_MODULES, TopBarComponent } from 'src/app/Shared/shared-imports';

@Component({
  selector: 'app-ops-booth-history',
  imports: [TopBarComponent, SYNCFUSION_MODULES, ANGULAR_MODULES, OperationsComponent],
  standalone: true,
  templateUrl: './ops-booth-history.html',
  styleUrl: './ops-booth-history.scss'
})
export class OpsBoothHistory {
isCollapsed: boolean = true;

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }
}
